import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/common';
import { devLog } from './utils';

const indexElement = document.getElementById('blogIndex');

if (!indexElement) {
  devLog.error('Blog index element not found');
} else {
  const root = createRoot(indexElement);
  root.render(
    <React.StrictMode>
      <ErrorBoundary
        enableRetry={true}
        maxRetries={3}
        onError={(error, errorInfo) => {
          // Log errors for debugging in development
          if (process.env.NODE_ENV === 'development') {
            devLog.error('App Error:', error, errorInfo);
          }
        }}
      >
        <App
          url={indexElement.getAttribute('url') ?? ''}
          layout={indexElement.getAttribute('layout') ?? ''}
          blogElementIndexId={indexElement.getAttribute('blogElementIndexId') ?? ''}
          displayCategories={indexElement.getAttribute('displayCategories') ?? ''}
          displayTags={indexElement.getAttribute('displayTags') ?? ''}
          perPage={indexElement.getAttribute('perPage') ?? '10'}
          featuredTitle={indexElement.getAttribute('featuredTitle') ?? ''}
          formToken={indexElement.getAttribute('formToken') ?? ''}
          sidebar={indexElement.getAttribute('sidebar') ?? 'false'}
          blogSearch={indexElement.getAttribute('blogSearch') ?? 'false'}
          markup={indexElement.getAttribute('markup') ?? ''}
          featuredMarkup={indexElement.getAttribute('featuredMarkup') ?? ''}
        />
      </ErrorBoundary>
    </React.StrictMode>
  );
}
